import { useSubscription } from 'urql';
import {
  CallDetailErrorsSubscription,
  CallDetailLogSubscription,
  CallDetailRecordingsSubscription,
  CallDetailSessionSubscription,
  CallDetailStepsSubscription,
  CallDetailVoicemailsSubscription,
} from './call-graphql';

export function useCallDetail(organizationId: string, callControlId: string) {
  const [{ data: logData }] = useSubscription({
    query: CallDetailLogSubscription,
    variables: { organizationId, callControlId },
  });
  const [{ data: sessionData }] = useSubscription({
    query: CallDetailSessionSubscription,
    variables: { organizationId, callControlId },
  });
  const [{ data: stepData }] = useSubscription({
    query: CallDetailStepsSubscription,
    variables: { organizationId, callControlId },
  });
  const [{ data: recordingData }] = useSubscription({
    query: CallDetailRecordingsSubscription,
    variables: { organizationId, callControlId },
  });
  const [{ data: voicemailData }] = useSubscription({
    query: CallDetailVoicemailsSubscription,
    variables: { organizationId, callControlId },
  });
  const [{ data: errorData }] = useSubscription({
    query: CallDetailErrorsSubscription,
    variables: { organizationId, callControlId },
  });

  if (!logData || !sessionData || !stepData || !recordingData || !voicemailData || !errorData) return null;

  return {
    log: logData.callLogs[0] ?? null,
    session: sessionData.callSessions[0] ?? null,
    steps: stepData.callSteps,
    recordings: recordingData.callRecordings,
    voicemails: voicemailData.voicemails,
    errors: errorData.callErrors,
  };
}
